<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/targetResponsibility/personal' }">个人责任书</el-breadcrumb-item>
        <el-breadcrumb-item>个人责任书详情/考核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="innerBox content">
      <!-- <el-divider><span style="font-size: 18px;color: #666666">详情</span></el-divider> -->
      <div style="width: 80%;margin: auto">
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: 666666; font-size: 16px">基础信息</span>
          </el-divider>
        </div>
        <div class="detailBox">
          <div>
            责任书标题：
            <span>{{ obj.resTitle }}</span>
          </div>
          <div>
            部门：
            <span>{{ obj.resDepName }}</span>
          </div>
          <div>
            岗位：
            <span>{{ obj.resJobName }}</span>
          </div>
          <div>
            员工：
            <span>{{ obj.resEmpName }}</span>
          </div>
          <div>
            制定人：
            <span>{{ obj.proName }}</span>
          </div>
          <div>
            制定日期：
            <span>{{ obj.proTime }}</span>
          </div>
          <div>
            状态：
            <span>{{ typeList[obj.status] }}</span>
          </div>
          <div>
            签字时间：
            <span>{{ obj.signTime }}</span>
          </div>
          <div>
            预定考核时间：
            <span>{{ obj.checkTime }}</span>
          </div>
          <div>
            考核标准：
            <span>{{ obj.checkNorm }}</span>
          </div>
          <div>
            考核人：
            <span>{{ obj.checkEmpName }}</span>
          </div>
          <div>
            年度：
            <span>{{ obj.yeas }}</span>
          </div>
          <div>
            签字文件：
            <img :src="host + obj.signFileUrl" alt="" style="width: 200px;vertical-align: top;">
            <!-- <span>{{ obj.signFileName + obj.signFileUrl }}</span> -->
          </div>
        </div>
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: 666666; font-size: 16px">考核记录</span>
          </el-divider>
        </div>
        <el-table :data="obj.assessList" border max-height="600" style="width: 100%">
          <el-table-column
            type="index"
            :index="(index) => {return index + 1}"
            width="80"
            label="序号"
          ></el-table-column>
          <el-table-column prop="assessScore" label="考核分数"></el-table-column>
          <el-table-column prop="assessContent" show-overflow-tooltip label="内容"></el-table-column>
          <el-table-column prop="gmtCreate" label="时间"></el-table-column>
          <el-table-column prop="checkUserName" label="考核人"></el-table-column>
          <el-table-column prop="checkUserName" label="是否通过">
            <template slot-scope="{ row }">
              <span v-if="row.checkStatus === 0">通过</span>
              <span v-else>未通过</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{row}">
              <span style="cursor: pointer;color: red" @click="deteleDetail(row.id)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  personalResponseInfo,
  responsibilityDelete
} from "@/api/processManager";
export default {
  name: "standardDetail",
  data() {
    return {
      userId: "",
      obj: {},
      tableData: [],
      typeList: ["预审批", "部门审批", "公司审批", "审批完成"],
      form: {
        id: "",
        pass: 0,
        auditContent: ""
      },
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");
    console.log(this.userId);
    this.form.id = this.$route.params.id;
    this.getDetail();
  },
  methods: {
    getDetail() {
      personalResponseInfo(this.$route.params.id).then(res => {
        this.obj = res.body.data;
      });
    },
    // 删除详情里面的表格
    deteleDetail(id) {
      responsibilityDelete(id).then(res => {
        this.$message.success('删除成功')
        this.getDetail()
      })
    },
  }
};
</script>

<style scoped>
.detailBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.detailBox div {
  width: 50%;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.tableBox {
  margin-top: 15px;
}
.tableBox .tableBoxTitle {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.a {
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.detailBox > div > span {
  color: #888888;
}
.a > span {
  color: #888888;
}
.innerBox .el-form-item {
  margin-bottom: 5px;
}
pre {
  line-height: 20px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px;
}
</style>